const isProduction =
  window.location.hostname === "provider-web.services.orcicare.com";

export const AI_CHART_URL = isProduction
  ? "https://aichart.services.orcicare.com"
  : "https://aichart-test.services.orcicare.com";
